import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    id: { label: i18n.t('app.id'), value: '' },
    name: { label: i18n.t('app.name'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
    company: { label: i18n.tc('companies.entity_name', 1), value: '' },
    role: { label: i18n.tc('app.role', 1), value: '' },
    activo: { label: i18n.t('app.active'), value: '' },
    tipoAuth: { label: i18n.t('users.tipo_auth'), value: '' },
    verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
    verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
    cliente: { label: i18n.t('clients.entity_name'), value: '' },
    idioma: { label: i18n.t('app.language'), value: '' },
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'idUsuario', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Cliente',
      width: '250px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      },
    },
    { field: 'Usuario', width: '250px', title: i18n.t('users.entity_name'), columnMenu: 'myTemplate', locked: false },
    { field: 'Email', width: '250px', title: i18n.tc('users.email', 1), columnMenu: 'myTemplate', locked: false },
    { field: 'idRol', width: '200px', title: i18n.tc('app.role'), format: 'ROLES', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    {
      field: 'Activo',
      title: i18n.t('app.active'),
      hidden: false,
      columnMenu: 'myTemplate',
      width: '100px',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') } 
    },
    { field: 'idTipoAutenticacion', width: '220px', title: i18n.t('users.tipo_auth'), format: 'TIPOS_AUTH', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'LangCode', width: '200px', title: i18n.t('app.language'), format: 'TIPOS_IDIOMA', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'Grupos', width: '440px', title: i18n.t('groups.header'), columnMenu: 'myTemplate', locked: false, cell: 'groupsTemplate', type: 'boolean', sortable: false, groupable: false },
    { field: 'idEstado', width: '440px', title: i18n.t('app.status'), columnMenu: 'myTemplate', locked: false, cell: 'tagsTemplate', type: 'boolean', hidden: true, sortable: false, groupable: false },
    { field: 'VerTodoEstados', width: '225px', title: i18n.t('configurations.ver_todo_statuses'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'VerTodoEmpresas', width: '225px', title: i18n.t('configurations.ver_todo_companies'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { 
      field: 'idCliente', 
      title: i18n.t('clients.id_client'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      }, 
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
